import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/2 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = { class: "flex flex-row justify-between items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Upload files", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mt-2" }, " Upload the documents that are associated with the employment relationship, such as the resume, contract, etc. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_10 = { class: "flex flex-col items-center justify-center" }
const _hoisted_11 = { class: "flex flex-row items-center justify-center rounded-full px-6 bg-primary w-1/2 h-16 hover:cursor-pointer" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "Browse files", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mt-4" }, "You can upload PDF or DOC/XLS. The maximum size of files is 5MB.", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_15 = { class: "flex flex-row justify-between items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", { class: "border-2 border-primary text-primary rounded-full px-6 py-4" }, " Cancel ", -1)
const _hoisted_17 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_7)
              ]),
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.names, (name, i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: i,
                    class: "mb-2"
                  }, _toDisplayString(name), 1))
                }), 128)),
                _createElementVNode("label", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("input", {
                    type: "file",
                    accept: "application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    class: "hidden",
                    multiple: "",
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args)))
                  }, null, 32)
                ])
              ]),
              _hoisted_13,
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadFiles && _ctx.uploadFiles(...args))),
                  class: "bg-primary text-white rounded-full px-6 py-4"
                }, " Submit ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17))
      : _createCommentVNode("", true)
  ]))
}